var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4217 21.4216C11.7424 21.2414 11.0674 21.033 10.3881 20.8571C8.29045 20.3144 6.82295 17.618 6.56448 15.5578C6.36155 13.9425 6.65633 12.2926 7.18609 10.7555C7.74361 9.13599 8.62795 7.54032 10.072 6.65022C10.8794 6.15307 11.815 5.90558 12.7485 5.77749C13.5602 5.66677 14.3826 5.63855 15.1986 5.69499C17.3881 5.84913 19.6118 6.67627 21.0536 8.35661C22.2904 9.79814 22.8522 11.7737 22.7348 13.682C22.6173 15.5903 21.8504 17.427 20.7226 18.9553C19.4067 20.7377 17.1339 21.9513 14.9209 21.8514C14.0686 21.8123 13.2419 21.6343 12.4217 21.4172V21.4216Z",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.303 18.3577C12.8954 18.2496 12.4904 18.1246 12.0829 18.019C10.8243 17.6934 9.94377 16.0756 9.78869 14.8394C9.66693 13.8703 9.8438 12.8803 10.1617 11.9581C10.4962 10.9864 11.0268 10.029 11.8932 9.49491C12.3776 9.19661 12.939 9.04812 13.4991 8.97127C13.9861 8.90483 14.4796 8.8879 14.9692 8.92177C16.2829 9.01425 17.6171 9.51054 18.4822 10.5187C19.2243 11.3837 19.5613 12.569 19.4909 13.714C19.4204 14.859 18.9602 15.961 18.2835 16.878C17.494 17.9474 16.1303 18.6755 14.8025 18.6156C14.2912 18.5922 13.7952 18.4854 13.303 18.3551V18.3577Z",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34603 20.2381C8.29988 22.7581 6.2229 24.6345 5.18058 27.1566C4.87785 27.8901 4.69008 28.8199 5.15759 29.4426C5.48332 29.8772 6.05621 30.0235 6.56396 29.9211C7.06979 29.8187 7.52005 29.5032 7.9205 29.1501C9.95533 27.3509 11.2774 23.97 12.1875 21.2912",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.eec7dfb7a1e1655babd86cd2582e801a.svg";
export { ForwardRef as ReactComponent };